// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopVehicleTransactionControllerGetVehicleTransactionsData } from './EshopVehicleTransactionControllerGetVehicleTransactionsData.gen';
import type { EshopVehicleTransactionControllerGetVehicleTransactionsErrors } from './EshopVehicleTransactionControllerGetVehicleTransactionsErrors.gen';
import type { EshopVehicleTransactionControllerGetVehicleTransactionsResponses } from './EshopVehicleTransactionControllerGetVehicleTransactionsResponses.gen';
import type { Options } from './Options.gen';

export class EshopVehicleTransactionController {
    /**
     * Get vehicle transactions.
     */
    public static getVehicleTransactions<ThrowOnError extends boolean = false>(options?: Options<EshopVehicleTransactionControllerGetVehicleTransactionsData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopVehicleTransactionControllerGetVehicleTransactionsResponses, EshopVehicleTransactionControllerGetVehicleTransactionsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/vehicle-transactions',
            ...options
        });
    }
}
